import React, { Component }                    from 'react'
import { message, Popover, Button, Icon, Spin} from 'antd'
import BlockUi                                 from '@availity/block-ui'

import CloudFlyerAPI from '../../../api/CloudFlyerAPI'
import EmptyState from '../../Shared/EmptyState/index'

import s3Icon         from '../../../assets/logo/s3-three.png'
import wasabiIcon     from '../../../assets/logo/wasabi-bnw-selected.png'

import '@availity/block-ui/dist/index.css'
import './styles.scss'

export default class MovePopover extends Component {

    constructor (props) {
        super(props)
        this.state = {
            loading   : true,
            files     : [],
            fileItems : []
        }
    }

    open = (files, on_close) => this.setState({files, on_close}, this.list_directories)

    list_directories = ({id, bucket_name, path}={}) =>{
        this.setState({loading:true})
        CloudFlyerAPI
            .storages
            .directories(id, bucket_name, path)
            .then(({data:{items, out, id, bucket_name, bucket_id, path}}) => {
                this.setState({fileItems: items, out, id, bucket_name, bucket_id, path, loading: false});
            })
            .catch((err)=>{
                message.error(err.message)
                this.setState({loading:false})
            })
    }

    on_cancel = ()=> this.setState({visible:false})

    on_loading = loading => this.setState({loading})

    on_browse_back = ()=> this.list_directories(this.state.out)

    on_refresh = ()=> this.list_directories(this.state)

    on_visible_change = ()=> this.setState({visible:!this.state.visible})

    // fix b2 
    on_submit = ()=> {
        this.setState({loading:true})
        const {id, bucket_name,bucket_id, path} = this.state
        this.state.on_close({id, bucket_name, bucket_id, path})
    }

    render() {
        const {id, bucket_name,  path, fileItems, loading, out, files=[], visible} = this.state
        const {target} = this.props
        return (
            <Popover title={[
                <Button ghost icon="arrow-left" size={'small'} key={'button'} disabled={!out} onClick={this.on_browse_back}/>,
                <span key={'span'}>{path ? path : (target.props.title + (files.length === 1 ? (files[0].basename||'') : (files.length + ' files ')) )}</span>,
                <Icon type="close" key={'icon'} onClick={this.on_cancel}/>
            ]}
                     trigger="click"
                     overlayClassName={'move-popover'}
                     placement="left"
                     visible={visible}
                     onVisibleChange={this.on_visible_change}
                     content={
                         <BlockUi className='controls' blocking={loading}>
                             <div className={'files'}>
                                 {
                                     (loading || fileItems.length) ?
                                         (fileItems.map((item, index) =>(
                                             <div className={'file'} key={index} onClick={e=> {
                                                 e.stopPropagation()
                                                 this.list_directories(item)
                                             }}>
                                                 {
                                                     item.account_type_id === 'aws'?
                                                         <img src={s3Icon}/>: (item.account_type_id === 'wasabi'? <img src={wasabiIcon}/>: <Icon type="folder"/>)
                                                 }
                                                 <span>{item.name||''}</span>
                                                 <Button ghost icon='right' size={'small'}
                                                         onClick={e => {
                                                             e.stopPropagation()
                                                             this.list_directories(item)
                                                         }}/>
                                             </div>
                                         ))):<EmptyState on_click={e=> {
                                             (e && e.stopPropagation())
                                             this.on_refresh()
                                         }} title={'no directory found'}/>
                                 }
                             </div>

                             <div className={'footer'}>
                                 <Button ghost icon="folder-add" size={'small'} key={'button'}
                                         disabled={true}
                                         onClick={e=> {
                                             e.stopPropagation()
                                             this.on_browse_back()
                                         }}/>

                                 <Button
                                     disabled={!id || !bucket_name}
                                     onClick={e=> {
                                         e.stopPropagation()
                                         return this.on_submit()
                                     }}>
                                     { (target.props.title).split(" ")[0].toUpperCase() }
                                 </Button>
                             </div>
                         </BlockUi>
                     }>
                {target}
            </Popover>
        )
    }
}
